import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { addDeliveryRegion as universalAddDeliveryRegion, createShippingOption as universalCreateShippingOption, deleteShippingOption as universalDeleteShippingOption, getShippingOption as universalGetShippingOption, queryShippingOptions as universalQueryShippingOptions, removeDeliveryRegion as universalRemoveDeliveryRegion, updateExtendedFields as universalUpdateExtendedFields, updateShippingOption as universalUpdateShippingOption, } from './ecom-v1-shipping-option-shipping-options.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function createShippingOption(httpClient) {
    return (shippingOption) => universalCreateShippingOption(shippingOption, 
    // @ts-ignore
    { httpClient });
}
export function getShippingOption(httpClient) {
    return (shippingOptionId) => universalGetShippingOption(shippingOptionId, 
    // @ts-ignore
    { httpClient });
}
export function updateShippingOption(httpClient) {
    return (_id, shippingOption) => universalUpdateShippingOption(_id, shippingOption, 
    // @ts-ignore
    { httpClient });
}
export function deleteShippingOption(httpClient) {
    return (shippingOptionId) => universalDeleteShippingOption(shippingOptionId, 
    // @ts-ignore
    { httpClient });
}
export function queryShippingOptions(httpClient) {
    return () => universalQueryShippingOptions(
    // @ts-ignore
    { httpClient });
}
export function updateExtendedFields(httpClient) {
    return (_id, namespace, options) => universalUpdateExtendedFields(_id, namespace, options, 
    // @ts-ignore
    { httpClient });
}
export function addDeliveryRegion(httpClient) {
    return (shippingOptionId, deliveryRegionId, options) => universalAddDeliveryRegion(shippingOptionId, deliveryRegionId, options, 
    // @ts-ignore
    { httpClient });
}
export function removeDeliveryRegion(httpClient) {
    return (shippingOptionId, deliveryRegionId, options) => universalRemoveDeliveryRegion(shippingOptionId, deliveryRegionId, options, 
    // @ts-ignore
    { httpClient });
}
export const onShippingOptionCreated = EventDefinition('wix.ecom.v1.shipping_option_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onShippingOptionDeleted = EventDefinition('wix.ecom.v1.shipping_option_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onShippingOptionUpdated = EventDefinition('wix.ecom.v1.shipping_option_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export { ConditionType, LogicalOperator, SortOrder, WebhookIdentityType, } from './ecom-v1-shipping-option-shipping-options.universal.js';
//# sourceMappingURL=ecom-v1-shipping-option-shipping-options.public.js.map